import styled, { keyframes } from 'styled-components/macro';

export const Wrapper = styled.div<{ size: number | string}>`
  position: relative;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`;

export const CircleBackground = styled.circle<{ strokeWidth: number }>`
  fill: none;
  stroke: ${({ theme }) => theme.colorPalette.grey.grey1};
  stroke-width: ${({ strokeWidth }) => strokeWidth};
`;

const animateProgress = (circumference: number, offset: number) => keyframes`
  from {
    stroke-dashoffset: -${circumference};
  }
  to {
    stroke-dashoffset: -${offset};
  }
`;

export const CircleProgress = styled.circle<{ strokeWidth: number; offset: number; circumference: number }>`
  fill: none;
  stroke: ${({ theme }) => theme.colorPalette.turquoise.dark};
  stroke-width: ${({ strokeWidth }) => strokeWidth};
  stroke-linecap: round;
  stroke-dasharray: ${({ circumference }) => circumference};
  stroke-dashoffset: ${({ offset }) => -offset}; /* Invert the offset */
  animation: ${({ offset, circumference }) => animateProgress(circumference, offset)} 1s ease forwards;
`;

export const PercentageText = styled.text`
  fill: ${({ theme }) => theme.colorPalette.turquoise.dark};
  font-size: ${({ theme }) => theme.fontSizePalette.xLarge};
  font-weight: ${({ theme }) => theme.fontWeightPalette.bold};
  text-anchor: middle;
  dominant-baseline: middle;
`;
